import { DateTime, DurationLikeObject, LocaleOptions } from "luxon";

const daysOfWeek = ["Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado", "Domingo"];
const monthsOfYear = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

type DateParam = DateTime | Date | string;
type UnitType = keyof DurationLikeObject;

/**
 * Transforma a data passada por parâmetro para o formato DateTime do luxon.
 * @param {DateTime | Date | string} date
 * @returns
 */
export const transformDateToType = (date: DateParam): DateTime => {
	//fiz a rotina abaixo devido o ios precisa ter o timezone
	if (typeof date == "string" && !date.includes("T")) date = date.replace(" ", "T");

	if (date instanceof DateTime) {
		return date;
	} else if (date instanceof Date) {
		return DateTime.fromJSDate(date);
	}

	return DateTime.fromJSDate(new Date(date));
};

/**
 * Verifica se a data é válida.
 * @param dateToValidate Data a ser validada;
 * @returns {boolean} true caso data for válida;
 */
export const isValidDate = (dateToValidate: DateParam): boolean => {
	return transformDateToType(dateToValidate).isValid;
};

/**
 * Formata data para o formato passado, seguindo os padrões de token do luxon: {@link https://moment.github.io/luxon/#/formatting?id=table-of-tokens};
 * @param format Formato desejado de formatação;
 * @param dateToFormat Data que deverá ser formatada, caso não for passada, será usada a data de hoje;
 * @param opts Opções específicas
 * @returns {string} Data formatada no formato desejado
 */
export const formatDate = (format: string, dateToFormat?: DateParam, opts?: LocaleOptions): string => {
	//fiz a rotina abaixo devido o ios precisa ter o timezone
	if (typeof dateToFormat == "string" && !dateToFormat.includes("T")) dateToFormat = dateToFormat.replace(" ", "T");

	const date = transformDateToType(dateToFormat || new Date()).setLocale("PT-br");
	let dataFormated = date.toFormat(format, opts);
	//isso é uma gabiarra por favor achar uma opção melhor
	daysOfWeek.forEach(dayOfWeek => {
		dataFormated = dataFormated.replaceAll(dayOfWeek.toLowerCase(), dayOfWeek);
	});
	monthsOfYear.forEach(month => {
		dataFormated = dataFormated.replaceAll(month.toLowerCase(), month);
	});
	return dataFormated;
};

/**
 * @param amount Quantidade a ser incrementada;
 * @param unit Unidade que será incrementada, caso não for passada será incrementado em milisegundos;
 * @param dateToIncrement Data à qual será incrementada, caso não for passada será a data atual;
 * @returns Data incrementada no formato DateTime do luxon
 */
export const incrementOnDate = (amount: number, unit?: UnitType, dateToIncrement?: DateParam) => {
	const date = transformDateToType(dateToIncrement || new Date());
	if (unit) {
		const unitObj = {} as DurationLikeObject;
		unitObj[unit] = amount;
		return date.plus(unitObj);
	} else {
		return date.plus(amount);
	}
};

/**
 * Retorna o nome do dia da semana, da data passada por parâmetro.
 * @param date Data à qual deseja saber o nome do dia da semana;
 * @returns {string} Nome do dia da semana
 */
export const getDayOfWeekName = (date: DateParam): string => {
	//fiz a rotina abaixo devido o ios precisa ter o timezone
	if (typeof date == "string" && !date.includes("T")) date = date.replace(" ", "T");
	return daysOfWeek[transformDateToType(date).setLocale("pt-BR").weekday - 1];
};

/**
 * Retorna o nome do mês do ano, da data passada por parâmetro.
 * @param date Data à qual deseja saber o nome do mês do ano;
 * @returns {string} Nome do mês do ano
 */
export const getMonthOfYearName = (date: DateParam): string => {
	//fiz a rotina abaixo devido o ios precisa ter o timezone
	if (typeof date == "string" && !date.includes("T")) date = date.replace(" ", "T");
	return monthsOfYear[transformDateToType(date).setLocale("pt-BR").month - 1];
};
